var React = require('react');

function StepArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 21.0174C20.4305 21.0174 38.4773 19.5923 56.8646 19.5923C73.5192 19.5923 90.2382 20.3048 106.741 20.3048C111.533 20.3048 115.088 13.2314 114.579 8.90441C114.424 7.58487 106.252 8.19188 107.81 8.19188C110.539 8.19188 112.713 9.48121 115.292 9.61694C117.044 9.70917 122.311 9.61694 120.557 9.61694C119.223 9.61694 115.527 6.75423 115.292 5.34178C114.188 -1.27789 109.841 3.41878 108.166 6.76683","stroke":"black","strokeOpacity":"0.15","strokeWidth":"3","strokeLinecap":"round"}));
}

StepArrow.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 123 23","fill":"none"};

module.exports = StepArrow;

StepArrow.default = StepArrow;
